import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Get error details from query parameters
  const reason = searchParams.get('reason');
  const message = searchParams.get('message');

  // Map error reasons to user-friendly messages
  const getErrorMessage = () => {
    if (message) {
      return decodeURIComponent(message);
    }
    
    switch (reason) {
      case 'missing-token':
        return 'No authorization token was provided in the URL.';
      case 'invalid-token':
        return 'The authorization token is invalid or has expired.';
      case 'validation-failed':
        return 'Token validation failed. Please contact your administrator.';
      case 'network-error':
        return 'Unable to connect to the server. Please check your internet connection.';
      case 'server-error':
        return 'A server error occurred. Please try again later.';
      case 'unauthorized':
        return 'You are not authorized to access this resource.';
      default:
        return 'You don\'t have permission to access this resource. Please contact your administrator if you believe this is an error.';
    }
  };

  const getErrorTitle = () => {
    switch (reason) {
      case 'missing-token':
      case 'invalid-token':
        return 'Invalid Token';
      case 'validation-failed':
        return 'Validation Failed';
      case 'network-error':
        return 'Connection Error';
      case 'server-error':
        return 'Server Error';
      default:
        return 'Access Denied';
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Card className="text-center shadow-lg" style={{ maxWidth: '500px' }}>
        <Card.Body className="p-5">
          <div className="mb-4">
            <span style={{ fontSize: '4rem' }}>🔒</span>
          </div>
          <Card.Title as="h2" className="text-danger mb-3">
            {getErrorTitle()}
          </Card.Title>
          <Card.Text className="text-muted mb-4">
            {getErrorMessage()}
          </Card.Text>
          <div className="alert alert-warning">
            <small>
              <strong>Need Help?</strong> {reason?.includes('token') 
                ? 'Please check your email for a valid authorization link.' 
                : 'You need to be an HR Manager, CFO, Admin, or have a valid authorization token.'}
            </small>
          </div>
          <div className="d-flex gap-2 justify-content-center">
            <Button 
              variant="primary" 
              onClick={() => navigate('/login')}
            >
              Go to Login
            </Button>
            <Button 
              variant="outline-secondary" 
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Unauthorized;
